export default __webpack_public_path__ + "static/media/bitbucket.dfa1f5d6.svg";